export enum VasiConstants {
  GET_VASI_REQ = 'GET_VASI_REQ',
  GET_VASI_OK = 'GET_VASI_OK',
  GET_VASI_KO = 'GET_VASI_KO',
}
